import { render, staticRenderFns } from "./ChangeName.vue?vue&type=template&id=35681812&scoped=true"
import script from "./ChangeName.vue?vue&type=script&lang=js"
export * from "./ChangeName.vue?vue&type=script&lang=js"
import style0 from "./ChangeName.vue?vue&type=style&index=0&id=35681812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35681812",
  null
  
)

export default component.exports